<script>
  import { tick } from 'svelte'
  import { onMount } from 'svelte'
  import { createPostRequest } from '../../src/create_request'
  import { focus } from '../../src/utils'
  import { cart } from '../../src/data_storage.js'
  cart.useLocalStorage()
  import { _, locale, locales } from 'svelte-i18n'

  export let shop
  export let order
  export let signedIn
  export let done_handler

  let value
  let payment = ""
  let errors = null

  function handleSubmit() {
    fetch(createPostRequest('/cart/checkout_payment.json',
                        'POST',
                        JSON.stringify({ order: { payment_option: value}, slug: shop.slug, order_id: order.id})))
      .then(response => response.json())
      .then(data => {
        console.log('checkout_payment:' + shop.slug)
        console.log(data)
        if (data.errors) {
          // alert(data.errors.email)
          error = data.errors.email
        } else if (data.id) {
          if (done_handler) {
            done_handler(data)
          }
        } else {
          error = "Something went wrong, try again later."
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    console.log("checkoutPayment onMount " + shop.slug)
    if (order.payment_option) {
      value = order.payment_option
    }
  })
</script>

<style>
</style>

<div class="frame mt-3 mx-4">
  <div class="text-lg">{$_('please_choose_payment')}</div>
  <form class="form" on:submit|preventDefault={handleSubmit}>
    <div class="flex flex-row gap-2">
      <div class="payment-field">
        <label for="payment">{$_('payment_option')}:</label>
        <select id="payment" bind:value class="rounded-md drop-shadow-md bg-transparent focus:ring-0">
          {#each shop.settings.payment_options as option}
            <option value={option}>{option}</option>
          {/each}
        </select>
      </div>
    </div>
    {#if errors}
      <div class="mt-3 bg-red-100 flex flex-col items-center justify-center">
        <div>{#if (errors['payment_option'])}{$_('payment_option')} {errors['email']}{/if}</div>
        <div>{#if (errors['base'])}{errors['base']}{/if}</div>
      </div>
    {/if}
    <div class="flex flex-row justify-center items-center">
      <button id="continue-payment" class="btn" type="submit">{$_('continue')}</button>
    </div>
  </form>
</div>
